import { render, staticRenderFns } from "./vFormSelect.vue?vue&type=template&id=47827099"
import script from "./vFormSelect.vue?vue&type=script&lang=js"
export * from "./vFormSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports